import {Trans, useTranslation} from '@/translations/i18n.tsx'
import {Alert} from '@components/ui/alert'
import {Link} from 'react-router-dom'
import {routes} from '@utilities/constants/routes'

export const AvailabilityAlert = ({onClose}: {onClose: () => void}) => {
    const {t} = useTranslation()

    return (
        <Alert
            title={t('commons:availability_alert_heading')}
            description={
                <Trans
                    i18nKey="commons:availability_alert_description"
                    components={{
                        Link: <Link className="underline cursor-pointer" to={routes.SETTINGS.handle.fullPath} />
                    }}
                />
            }
            icon="error"
            onClose={onClose}
        />
    )
}
